import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "./Button";
import { A } from "../styles/appleClasses";

interface EmptyStateProps {
  message: string;
  heading?: string;
  backLabel?: string;
  showNewButton?: boolean;
  newButtonText?: string;
  newButtonPath?: string;
}

export default function EmptyState({
  message,
  heading = "Nothing here yet",
  backLabel = "Go Back",
  showNewButton,
  newButtonText = "New",
  newButtonPath,
}: EmptyStateProps) {
  const navigate = useNavigate();

  return (
    <div className="w-full flex flex-col items-center py-10 px-2">
      <div className={`w-full max-w-xl px-6 py-6 ${A.card}`}>
        <div className={`${A.title} mb-1`}>{heading}</div>

        <div className={`${A.body} text-gray-500`}>{message}</div>

        <div className="flex flex-wrap gap-3 mt-5">
          <Button
            variant="secondary"
            type="button"
            onClick={() => navigate(-1)}
            minWidth="auto"
          >
            {backLabel}
          </Button>

          {showNewButton && newButtonPath && (
            <Button
              variant="outline"
              type="button"
              onClick={() => navigate(newButtonPath)}
              minWidth="auto"
            >
              {newButtonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
